<template>
  <div v-if='loadingPage'>
    <oil-cap
        :title='capTitle.toUpperCase()'
        service-name="waybill"
        :search-filter="onSearchValueChange"
        :buttons='capButtons'
    />
    <v-divider class='my-2'/>
    <oil-table
        :keys='tableKey'
        :items='consignments'
        :paginate='waybills'
        :hide-footer="true"
        :item-counts="consignments.length+1"
        @paginateAction='paginate'
    >


      <template v-slot:Buyer='{value}'>
        {{ value.CompanyName }}
      </template>

      <template v-slot:Contract='{value}'>
        {{ value.Number }}
      </template>

      <template v-slot:Status='{value,object}'>

        <v-chip v-if='object.IsReturned' disabled color='danger'>
          возврат
        </v-chip>

        <v-chip v-else :color='status(value).color'>
          {{ status(value).value }}
        </v-chip>

      </template>

      <template v-slot:UpdatedAt='{value}'>
        {{ value | date }}
        <br>
        <small class='grey--text'>
          {{ value | time }}
        </small>
      </template>
      <template v-slot:PDFID='{value}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn class='mr-6' type='button' icon
                   @click="showMePdf('waybill/print',value)"
                   v-bind='attrs'
                   v-on='on'
            >
              <v-icon>
                mdi-pdf-box
              </v-icon>
            </v-btn>
          </template>
          <span>СКАЧАТЬ И ПЕЧАТЬ</span>
        </v-tooltip>
      </template>
      <template v-slot:Id='{value,object}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn :disabled='object.IsReturned' v-bind='attrs'
                   v-on='on' icon
                   @click.stop='handleRowClick(value)'>
              <v-icon color='primary'>
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          <span>РЕДАКТИ́РОВАТЬ</span>
        </v-tooltip>
      </template>
      <template v-slot:DeleteId='{value,object}'>

        <v-row>
          <v-col
              md='6'
              offset-md='3'
          >
            <oil-modal
                :disabled='object.IsReturned'
                :value='value'
                tooltipMessage='УДАЛИТЬ'
                mdiIcon='mdi-delete'
                :accept='deleteWaybill'
            />

          </v-col>
        </v-row>

      </template>

      <template v-slot:ReturnId='{value,object}'>

        <v-row>
          <v-col
              md='6'
              offset-md='3'
          >
            <oil-modal
                :value='value'
                tooltipMessage='Возврат'
                :disabled='object.IsReturned'
                mdiIcon='mdi-keyboard-return'
                :modal="{title:'Возврат',message:' '}"
                mdiColor='success'
                :accept='returnWaybill'
            >
              <template v-slot:other>
                <v-textarea
                    v-model='cause'
                    label='Причина'
                    outlined
                    dense
                />
              </template>

            </oil-modal>

          </v-col>
        </v-row>


      </template>
    </oil-table>
  </div>
</template>

<script>
import {waybillService} from '@/services/WayBillService'
import {cap, table} from '../setting/TTN.json'

export default {
  components: {
    OilTable: () => import('@/components/helper/oil.table'),
    OilCap: () => import('@/components/helper/oil.cap'),
    OilModal: () => import('@/components/helper/form/oil.delete.modal')
  },
  data: () => ({
    capTitle: cap.title,
    capButtons: cap.buttons,
    tableKey: table.keys,
    consignments: [],
    cause: '',
    loadingPage: false,
    statusLocal: {
      active: {value: 'Активный', color: 'success'},
      notsigned: {value: 'Неподписанный', color: 'lime'},
      special: {value: 'Особый', color: 'warning'},
      inactive: {value: 'Неактивный', color: 'red'},
      return: {value: 'возврат', color: ''}
    },
    waybills: {
      count: 0
    }
  }),
  async created() {
    await this?.paginate((this.currentPage - 1) * 10)
    this.loadingPage = true
  },
  methods: {
    async paginate(page) {
      const response = await waybillService.paginate(page)
      const {
        count,
        dates
      } = response.data
      this.waybills.count = count
      this.consignments = dates?.map(consignment => {
        return {
          Id: consignment.Id,
          DeleteId: consignment.Id,
          PDFID: consignment.Id,
          ReturnId: consignment.Id,
          IsReturned: consignment.IsReturned,
          TaxNo: consignment.Buyer.TaxNo,
          CompanyName: consignment.Buyer.CompanyName,
          ContractNumber: consignment.Contract.Number,
          Number: `${consignment.Contract.Number}-${consignment.Number}`,
          Status: consignment.Status
        }
      })
      return dates
    },
    status(value) {
      return this.statusLocal[value] || {
        value: value,
        color: ''
      }
    },
    openPdf(id, path) {
      window.open(process.env.VUE_APP_BACKEND_API + `/${path}/${id}`)
    },
    async onSearchValueChange(data) {
      if (!data) {
        await this.paginate((this.currentPage - 1) * 10)
        return
      }

      this.consignments = data?.map(consignment => {
        return {
          Id: consignment.Id,
          DeleteId: consignment.Id,
          PDFID: consignment.Id,
          ReturnId: consignment.Id,
          IsReturned: consignment.IsReturned,
          TaxNo: consignment.Buyer.TaxNo,
          CompanyName: consignment.Buyer.CompanyName,
          ContractNumber: consignment.Contract.Number,
          Number: `${consignment.Contract.Number}-${consignment.Number}`,
          Status: consignment.Status
        }
      })

    },
    handleRowClick(Id) {
      this.$router.push(`/waybill-update/${Id}`)
    },
    async deleteWaybill(id) {
      const response = await waybillService.delete(id)
      const isDelete = response.data
      if (isDelete) {
        const waybill = this.consignments.find(({Id}) => Id === id)
        const index = this.consignments.indexOf(waybill)
        this.consignments.splice(index, 1)
        this.$notify({
          group: 'mgs',
          type: 'success',
          title: `ТТН под номером ${waybill.Number} удачно удален`
        })
      }
    },
    async returnWaybill(id) {

      if (!this.cause?.trim()) {
        this.$notify({
          group: 'mgs',
          type: 'error',
          title: `укажите причину возврата`
        })
        return
      }

      const response = await waybillService.return(id, this.cause)
      const isReturn = response.data

      if (isReturn) {
        this.cause = ''
        const waybill = this.consignments.find(({Id}) => Id === id)
        const index = this.consignments.indexOf(waybill)
        this.consignments[index].IsReturned = isReturn
        this.consignments[index].Status = 'return'
        this.$notify({
          group: 'mgs',
          type: 'success',
          title: `ТТН под номером ${waybill.Number} удачно возвращен`
        })
      }
    }

  }
}

</script>
